import 'vendor/sticky-kit'
import 'vendor/jquery.debouncedresize.js'
import selectComponent from 'utilities/select-component'
import {$bpTablet} from 'utilities/grid-settings'
import 'vendor/jquery.debouncedresize'

export default class StickyKit {

    constructor(element, breakpoint = $bpTablet) {
        this.$component = selectComponent(element)
        this.breakpoint = breakpoint
        this.bindEvents()
    }

    bindEvents() {
        if (this.isWideEnough()) {
            this.stick()
        }

        $(window).on('debouncedresize', () => {

            if (this.isWideEnough()) {
                this.stick()
                return
            }

            this.unStick()
        })
    }

    isWideEnough() {
        if (this.breakpoint.matches) {
            return true
        }
        return false
    }

    stick() {
        this.$component.elements.child.stick_in_parent({
            parent: this.$component.elements.parent,
            offset_top: 130
        })
    }

    unStick() {
        this.$component.elements.child.trigger('sticky_kit:detach')
    }
}